import { trpc } from '@/shared/api/trpc';

// Reporter's own unresolved (open + in_progress) ticket count. Drives the
// header badge; kept fresh by invalidation on every ticket mutation (no
// polling), mirroring incidents.myUnresolvedCount. `enabled` lets callers
// defer the fetch until the badge is actually mounted.
export const useMyUnresolvedCount = (enabled = true) =>
  trpc.support.myUnresolvedCount.useQuery(undefined, { enabled });
